import { Button } from '@material-ui/core';
import { useFormState } from 'react-final-form';
import styled from 'styled-components';

const StyledButton = styled(Button)`
  box-shadow: 0px 4px 4px 0px #00000040;
  background: #225a91;
  font-size: 16px;
  font-weight: 500;
  line-height: 18.75px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-transform: none;
  height: 44px;
  border-radius: 6px;
`;

export const SubmitButton = () => {
  const { values } = useFormState({ subscription: { values: true } });
  const numberOfFilledSections = Object.values(values.interior_questions.subsections).reduce((acc: number, curr: any) => {
    if (!!curr.grade) {
      return acc + 1;
    }

    return acc;
  }, 0);

  const renderText = (() => {
    if (numberOfFilledSections === 0) {
      return 'Skip';
    }
    if (numberOfFilledSections === Object.keys(values.interior_questions.subsections).length) {
      return 'Save';
    }
    return 'Skip & Save';
  })();

  return (
    <StyledButton color="primary" variant="contained" type="submit">
      {renderText}
    </StyledButton>
  );
};
